'use client';
import { api } from '@/lib/providers/axios/api';
import { API_ROUTES } from '@/shared/constants/api-routes';
import { buildApiRoute } from '@/shared/functions/build-api-route';
import type { BaseDates } from '@/shared/interfaces/base-dates';
import type { DefaultPaginatedResponse } from '@/shared/interfaces/default-paginated-response';
import type { DefaultPaginationParams } from '@/shared/interfaces/default-pagination-params';
import type { Media } from '../../medias/get-blob';

export interface BannerSet extends BaseDates {
	id: string;
	name: string;
	active: boolean;
	routeId: string;
	route: Route;
	medias?: Array<Media>;
}

interface Route extends BaseDates {
	id: string;
	name: string;
	pageUrl: string;
	banner?: Array<BannerSet>;
}

export interface GetAllBannerSetsQueryParams extends Omit<DefaultPaginationParams, 'search'> {
	id?: string;
	active?: 'true' | 'false';
	name?: string;
	routeId?: string;
	pageUrl?: string;
}

export async function getAllBannerSets({
	name,
	page = 1,
	quantity = 5,
	active,
	routeId,
	pageUrl,
	id,
}: GetAllBannerSetsQueryParams): Promise<DefaultPaginatedResponse<Array<BannerSet>>> {
	const res = await api.get(buildApiRoute(API_ROUTES.GET.PUBLIC.GET_ALL_BANNERS), { params: { active, name, page, quantity, routeId, pageUrl, id } });
	return res.data;
}
